if (typeof JW === 'undefined') JW = {};
JW.Live = (function ($)
{
    var State = JW.State;

    var _pri = {};
    var publ = {};

    _pri.cname = 'LIVE';
    _pri.opts = {
        dbg_lvl:    1,
        urls: {
            test: '/_jss/live'
        }
    };

    _pri.inited          = false;
    _pri.scaled          = false;

    _pri.rx_load_lnk     = /^\/live\/([a-zA-Z0-9._-]+)(?:\/([a-zA-Z0-9._-]+))?\/?$/;
    _pri.rx_lc_lnk       = /^\/live\/([0-9]+)\/?$/;
    _pri.rx_lc_id        = /^[1-9][0-9]*$/;

    _pri.$style_elm      = null;
    _pri.$frm_llb        = [];
    _pri.req_id          = 0;
    _pri.s_txt           = '';
    _pri.$s_txt          = null;
    _pri.$s_check        = null;
    _pri.$s_geoloc       = null;
    _pri.$s_lat          = null;
    _pri.$s_lng          = null;
    _pri.geoloc          = null;
    _pri.s_check_val_buf = '';
    _pri.s_check_val_def = 'Bewerbungsmappen-Check';

    _pri.win_ext_win_id  = 'win_ext_open';
    _pri.roomObserver    = null;
    _pri.observe_lc_id   = '';
    _pri.observe_win_id  = 0;
    _pri.cont_req        = null;
    _pri.push_state      = true;

    _pri.$wrp_live       = null;
    _pri.lc_id_cur       = 0;
    _pri.cmp_names_map   = {};
    _pri.lss_childs_map  = null;
    _pri.cookie_msg      = 'Diese Seite benötigt Cookies.<div class="pt-3">Bitte leeren Sie Ihren Browser-Cache, und löschen Sie alle alten Cookies dieser Seite. Danach laden Sie bitte diese Seite neu.</div>';

    _pri.nsp             = '';
    _pri.slug            = '';
    _pri.lfair_id        = '0';
    _pri.lnk_acts        = ['ausstellerverzeichnis', 'messe', 'infos', 'ausstellerinfos', 'lobby', 'news', 'termine', 'videos', 'karte', 'features_wrap', 'video-chat-testraum', 'mitmachen', 'ausbildung', 'jobs'];

    _pri.win_loading_id  = '';
    _pri.got_wm_ready    = false;
    _pri.got_wm_pu       = false; // participantupdate

    _pri.meta_dsc        = '';
    _pri.meta_kws        = '';

    _pri.queue           =
    {
        show_hide_lcwrp: 0
    };

    _pri.extend = function()
    {
        // console.log('################## jw_live extend()');
        JW.ExtCommon(jQuery, publ, _pri);
    };

    publ.extend = function(jw)
    {
        _pri.dbgY('*** extend()');

        delete publ.init;

        if (typeof jw == 'function')
        {
            jw(jQuery, publ, _pri);
        }
    };

    publ.init = function()
    {
        _pri.dbgG('*** init()');

        if (_pri.inited)
        {
            return;
        }

        _pri.inited = true;
        _pri.page   = JW.Page;
        _pri.sioc   = JW.SiocLive;
        _pri.modal  = JW.Modal;

        _pri.$body  = $('body');
        _pri.$wrp_live = $('#wrp_live');
        if (_pri.$wrp_live.length != 1)
        {
            _pri.dbg('    no #wrp_live - return.');
            return;
        }

        // $('#jw_live').on('click', _pri.test1); // old test btn??? 220122

        $(document).on('click',            '.live-lnk',         _pri.liveLnkClick);
        $(document).on('click',            '#btn-chat-scale',   _pri.scaleChatClick);
        $(document).on('click',            '#btn-chat-leave',   _pri.leaveChatClick);
        $(document).on('click',            '#btn-chat-busy',    _pri.busyChatClick);
        $(document).on('click',            '#lc_admin_lnk',     _pri.lcAdminLnkClick);
        $(document).on('click',            '#lc_visitor_lnk',   _pri.lcVisitorLnkClick);
        $(document).on('show.bs.dropdown', '#dd_user_list',     _pri.setUserList);
        $(document).on('show.bs.dropdown', '#dd_kick_list',     _pri.setUserList);
        $(document).on('mousedown',        '#dd_waitings_list', _pri.setWaitingsList);
        $(document).on('click',            '.dd_user',          _pri.ddUserClick);
        $(document).on('click',            '#ext_lnk',          _pri.extLnkClick);
        // $(document).on('mouseup',   '#dd_waitings_list', function(e) {e.preventDefault(); e.stopImmediatePropagation(); e.stopPropagation(); return false;});
        // $(document).on('click',     '#dd_waitings_list', function(e) {e.preventDefault(); e.stopImmediatePropagation(); e.stopPropagation(); return false;});


        _pri.page.on('page:resize_done', _pri.onResizeDone);
        _pri.page.on('page:window_on_message', _pri.onWindowMsg);

        _pri.page.on('live:live_lnk_on_load', _pri.liveLnkOnLoad);
        _pri.page.on('live:llb_wrp_on_load', _pri.llbWrpOnLoad);
        _pri.page.on('live:llb_on_load', _pri.llbOnLoad);

        _pri.page.on('live:lc_wrp_on_load', _pri.lcWrpOnload);
        _pri.page.on('live:lcadmvis_on_load', _pri.lcAdmVisOnLoad);

        _pri.page.on('modal:logged_in', _pri.onModalLoggedIn);
        _pri.page.on('live_room:room_joined_adm', _pri.onRoomJoinedAdm);

        _pri.page.on('sio:on_lobby_msg',  _pri.onLobbyMsg);
        _pri.page.on('sio:on_states_map', _pri.onStatesMap);
        // _pri.page.on('sio:on_connect',    _pri.onConnect);
        // _pri.page.on('sio:on_auth',       _pri.onAuth);

        _pri.page.on('btn_tgl:click', _pri.onBtnTglClick);

        _pri.$frm_dnm = $('#frm_dnm');
        // if (_pri.$frm_dnm.length > 0)
        // {
        //     _pri.initLC();
        // }

        window.onpopstate = function(e)
        {
            if (e.state)
            {
                _pri.dbg('*** onpopstate() e.state:', e.state);
                if (typeof e.state === 'object' && typeof e.state.live_url === 'string')
                {
                    _pri.push_state = false;
                    _pri.loadLnk(e.state.live_url);
                }
                // document.getElementById("content").innerHTML = e.state.html;
                // document.title = e.state.pageTitle;
            }
        };

        _pri.initLive();
    };

    publ.onKickUser = function(meta)
    {
        _pri.dbg('*** onKickUser() meta:', meta);

        if (meta.lc_id == _pri.lc_id_cur)
        {
            if (_pri.$style_elm != null)
            {
                _pri.removeScale();
            }

            _pri.loadLlb();
        }
    };

    publ.onRoomJoinErr = function(meta, load_lc_wrp)
    {
        _pri.dbgR('*** onRoomJoinErr() meta:', meta);

        if (typeof load_lc_wrp === 'undefined')
        {
            load_lc_wrp = true;
        }

        if (_pri.$style_elm != null)
        {
            _pri.removeScale();
        }

        var room_id = meta.room_id_to;
        var lc_id   = 0;

        if (_pri.sioc.validRoomId(meta.room_id_to))
        {
            var lc_id = _pri.sioc.getLcIdByRoomId(meta.room_id_to);
        }

        if (lc_id > 0)
        {
            var msg;
            if (typeof meta.msg_state !== 'undefined' && meta.msg_state == State.STATE_MAX)
            {
                msg = 'Die maximale Anzahl von <em>' + meta.mx_user_cnt + ' Personen</em> in diesem Raum ist bereits erreicht.';
            }
            else
            {
                msg = 'Dieser Raum ist derzeit leider nicht verfügbar. Bitte versuchen Sie es später nocheinmal.';
            }

            if (load_lc_wrp)
            {
                _pri.loadLcWrp(lc_id);
            }
            _pri.modal.showMsg(msg, '', 'mwp-360');
        }
        else
        {
            _pri.loadLlb();
        }
    };

    publ.goToAdminRoom = function(room_id, do_enter)
    {
        _pri.dbg('*** goToAdminRoom() room_id:', room_id);

        do_enter = do_enter ? true : false;

        _pri.dbg('    do_enter:', do_enter);

        var lc_id = _pri.sioc.getLcIdByRoomId(room_id);

        if (lc_id == _pri.lc_id_cur)
        {
            var display_name = $('#inp_dnm').val();

            _pri.enterRoomAdm({
                room_id_to:   room_id,
                display_name: display_name
            });
        }
        else
        {
            _pri.cont_req = {
                data: {
                    dataType: 'json',
                    lfair_id: _pri.lfair_id,
                    lc_id: lc_id
                },
                url: '/_lc_wrp'
            };

            if (!do_enter)
            {
                // _pri.modal.get('/_lc_wrp', _pri.cont_req.data, _pri.modal.handleJSONRet);
                _pri.modalGet('/_lc_wrp', _pri.cont_req.data, _pri.modal.handleJSONRet);
            }
            else
            {
                // _pri.modal.get('/_lc_wrp', _pri.cont_req.data, function(ret, stat_str, jq_xhr) {
                //
                //     _pri.modal.handleJSONRet(ret, stat_str, jq_xhr);
                //
                //     if (jq_xhr.status == 200)
                //     {
                //         var display_name = $('#inp_dnm').val();
                //
                //         _pri.enterRoomAdm({
                //             room_id_to:   room_id,
                //             display_name: display_name
                //         });
                //     }
                // });
                _pri.modalGet('/_lc_wrp', _pri.cont_req.data, function(ret, stat_str, jq_xhr) {

                    _pri.modal.handleJSONRet(ret, stat_str, jq_xhr);

                    if (jq_xhr.status == 200)
                    {
                        var display_name = $('#inp_dnm').val();

                        _pri.enterRoomAdm({
                            room_id_to:   room_id,
                            display_name: display_name
                        });
                    }
                });
            }
        }
    };

    _pri.initLive = function()
    {
        _pri.dbgG('*** initLive()');

        _pri.slug     = _pri.$wrp_live.data('slug');
        _pri.nsp      = _pri.$wrp_live.data('nsp');
        _pri.lfair_id = _pri.$wrp_live.data('lfair_id');

        if (!_pri.isObj(_pri.lss_childs_map))
        {
            let cll = {
                _url: '/_jss/lsc',
                _msk: false,
                _dtp: 'JSON',
                _frmdt: {
                    fair_id: _pri.lfair_id
                }
            };

            _pri.modal.cll(cll, function(xhr) {
                let ret = JSON.parse(xhr.responseText);
                _pri.dbgG('*** on load /_jss/lsc ...');
                if (_pri.isObj(ret.lss_childs_map))
                {
                    _pri.dbg('    ', ret.lss_childs_map);
                    _pri.lss_childs_map = $.extend({}, ret.lss_childs_map);
                }
                else
                {
                    _pri.dbgR('    !!! ret.lss_childs_map is not an object!');
                    _pri.lss_childs_map = {};
                }
            });
        }

        var url_cont = _pri.$wrp_live.data('url_cont');
        _pri.dbgY('    url_cont:', url_cont);

        _pri.loadLnk(url_cont);
    };

    _pri.liveLnkOnLoad = function(e, ret)
    {
        _pri.dbg('*** liveLnkOnLoad() ret:', ret);

        if (!_pri.isObj(ret))
        {
            _pri.dbgR('    !!! ret is not an object!');
            return;
        }

        if (typeof ret.lc_id === 'undefined')
        {
            _pri.lc_id_cur = 0;
        }

        _pri.page.resize(undefined, undefined, 'cols2');

        // document.title = ret.page_title;
        $('title').html(ret.page_title);
        // window.history.pushState({live_url: ret.page_url}, ret.page_title, ret.page_url);
        _pri.pushState(ret);

        // 240314 commented - no more metatags by from news ...
        // let meta = document.getElementsByTagName('meta');
        // let meta_dsc = null;
        // let meta_kws = null;
        // let meta_tag;
        //
        // if (!_pri.isObj(meta) || !_pri.isObj(meta['description']))
        // {
        //     meta_tag = document.createElement('meta');
        //     meta_tag.setAttribute('name', 'description');
        //     meta_tag.content = 'Jobmessen und Ausbildungsmessen von JOBWOCHE';
        //     document.getElementsByTagName('head')[0].appendChild(meta_tag);
        // }
        //
        // if (!_pri.isObj(meta) || !_pri.isObj(meta['keywords']))
        // {
        //     meta_tag = document.createElement('meta');
        //     meta_tag.setAttribute('name', 'keywords');
        //     meta_tag.content = 'jobmesse,ausbildungsmesse,jobs,ausbildung,weiterbildung,jobwoche,stellenmarkt,messe,live-chat,bewerbung,kontakt,einstellung';
        //     document.getElementsByTagName('head')[0].appendChild(meta_tag);
        // }
        //
        // meta = document.getElementsByTagName('meta');
        // meta_dsc = meta['description'];
        // meta_kws = meta['keywords'];
        //
        //
        // if (_pri.meta_dsc === '' && meta_dsc != null)
        // {
        //     _pri.dbgG('    set def meta dsc to:', meta_dsc.content);
        //     _pri.meta_dsc = meta_dsc.content;
        // }
        //
        // if (_pri.meta_kws === '' && meta_kws != null)
        // {
        //     _pri.dbgG('    set def meta kws to:', meta_kws.content);
        //     _pri.meta_kws = meta_kws.content;
        // }
        //
        // if (typeof ret.meta_dsc === 'string')
        // {
        //     meta_dsc.content = ret.meta_dsc;
        // }
        // else if (_pri.meta_dsc != '')
        // {
        //     meta_dsc.content = _pri.meta_dsc;
        // }
        //
        // if (typeof ret.meta_kws === 'string')
        // {
        //     meta_kws.content = ret.meta_kws;
        // }
        // else if (_pri.meta_kws != '')
        // {
        //     meta_kws.content = _pri.meta_kws;
        // }
        //
        // _pri.dbgG('    def meta dsc:', _pri.meta_dsc);
        // _pri.dbgG('    def meta kws:', _pri.meta_kws);
    };

    _pri.loadLlb = function()
    {
        // _pri.cont_req = {
        //     data: {
        //         dataType: 'json',
        //         lfair_id: _pri.lfair_id
        //     },
        //     url: '/_llb_wrp'
        // };
        // _pri.modal.get('/_llb_wrp', _pri.cont_req.data, _pri.modal.handleJSONRet);
        _pri.loadLnk('/live/' + _pri.slug);
    };

    _pri.llbWrpOnLoad = function(e, ret)
    {
        _pri.dbg('*** onLlbWrpLoad() ret:', ret);

        _pri.sioc.leaveAll();
        _pri.lc_id_cur = 0;

        var $sels = _pri.$wrp_live.find('.jb-select');
        $.each($sels, function(k, v) {
            JW.InpSelect(jQuery, v);
        });

        _pri.page.resize();

        _pri.$frm_llb = $('#frm_llb');

        if (_pri.$frm_llb.length > 0)
        {
            JW.AjxFrm(jQuery, _pri.$frm_llb[0]);
            _pri.req_id = 0;
            _pri.initLbb();
        }

        var $llb_wrp_head = $('#llb_wrp_head');

        $llb_wrp_head.find('[data-toggle="tooltip"]').tooltip();

        // // document.title = ret.page_title;
        // $('title').html(ret.page_title);
        // // window.history.pushState({live_url: ret.page_url}, ret.page_title, ret.page_url);
        // _pri.pushState(ret);

        _pri.page.trigger('live:live_lnk_on_load', ret);
    };

    _pri.llbOnLoad = function(e, ret)
    {
        _pri.dbg('live:llb_on_load', ret);
        _pri.dbg('    req_id', ret.req_id, '_pri.req_id', _pri.req_id);
        if (typeof ret.req_id !== 'undefined' && ret.req_id == _pri.req_id && typeof ret.html !== 'undefined' && $.isPlainObject(ret.html))
        {
            _pri.dbg('    html ...');
            $.each(ret.html, function(k, v) {
                _pri.dbg('        ' + k);
                $(k).html(v);
            });

            var $wrp_llb = $('#wrp_llb');

            $wrp_llb.find('[data-toggle="tooltip"]').tooltip({
                html: true,
                // container: 'body',
                // trigger: 'click',
                // trigger : 'hover',
                template: '<div class="tooltip nosel mwp-360" role="tooltip"><div class="arrow"></div><div class="tooltip-inner mwp-360 px-3 pt-3 text-left"></div></div>',
                boundary: 'viewport'
            });

            $wrp_llb.find('.ls_card').on('click keyenter keyspace', function(e) {

                e.preventDefault();
                e.stopImmediatePropagation();
                e.stopPropagation();

                // $wrp_llb.find('[data-toggle="tooltip"]').tooltip('hide');
                $wrp_llb.find('[data-toggle="tooltip"]').tooltip('dispose');

                var $this = $(this);
                var lc_id = $this.data('lc_id');
                _pri.loadLcWrp(lc_id);
            });

            _pri.applyStatesMap();
        }
    };

    _pri.loadLcWrp = function(lc_id, meta)
    {
        _pri.dbgG('*** loadLcWrp() lvc_id:', lc_id);
        _pri.dbg('    meta:', meta);

        // let is_adm = _pri.sioc.isAdmForRoomId(_pri.sioc.getRoomIdByLcId(lc_id));
        // _pri.dbg('    is_adm:', is_adm);
        //
        // if (!is_adm)
        // {
        //     // check online state ...
        //
        //     let sm = _pri.sioc.getStatesMap();
        //     _pri.dbg('    states_map:', sm);
        //
        //     if (_pri.isObj(sm))
        //     {
        //         if (typeof sm[lc_id] === 'undefined' || (sm[lc_id] != State.STATE_OK && sm[lc_id] != State.STATE_EXISTING && sm[lc_id] != State.STATE_BUSY))
        //         {
        //
        //         }
        //     }
        // }

        _pri.cont_req = {
            data: {
                dataType: 'json',
                lfair_id: _pri.lfair_id,
                lc_id: lc_id
            },
            url: '/_lc_wrp?tkn=' + _pri.page.getUId()
        };

        if (typeof meta !== 'object' || typeof meta.go === 'undefined')
        {
            _pri.dbg('    1 get lc_wrp ...');
            // _pri.modal.get('/_lc_wrp', _pri.cont_req.data, _pri.modal.handleJSONRet);
            _pri.modalGet('/_lc_wrp', _pri.cont_req.data, _pri.modal.handleJSONRet);
        }
        else if (meta.go == 'vis')
        {
            _pri.dbg('    2 get lc_wrp ...');

            // _pri.modal.get('/_lc_wrp', _pri.cont_req.data, function(ret, stat_str, jq_xhr) {
            //
            //     _pri.modal.handleJSONRet(ret, stat_str, jq_xhr);
            //
            //     if (jq_xhr.status == 200)
            //     {
            //         _pri.enterRoomVis(meta);
            //     }
            // });

            _pri.modalGet('/_lc_wrp', _pri.cont_req.data, function(ret, stat_str, jq_xhr) {

                _pri.modal.handleJSONRet(ret, stat_str, jq_xhr);

                if (jq_xhr.status == 200)
                {
                    _pri.enterRoomVis(meta);
                }
            });
        }
    };

    _pri.lcWrpOnload = function(e, ret)
    {
        _pri.dbg('*** lcWrpOnload()', ret);

        _pri.sioc.leaveAll();

        _pri.lc_id_cur = ret.lc_id;
        _pri.cmp_names_map[ret.lc_id] = ret.cmp_name;


        // // document.title = ret.page_title;
        // $('title').html(ret.page_title);
        // // window.history.pushState({live_url: ret.page_url}, ret.page_title, ret.page_url);
        // _pri.pushState(ret);
        //
        // _pri.page.resize(undefined, undefined, 'cols2');



        setTimeout(function() {
            _pri.dbg('!!! AGAIN !!!');
            _pri.page.resize(undefined, undefined, 'cols2');
        }, 500);

        let failed = [];

        if (typeof ret.state !== 'object' || typeof ret.state.errcnt === 'undefined' || ret.state.errcnt == 0)
        {
            var features = _pri.getFeatures();

            $.each(features, function(k, v) {
                if (!v)
                {
                    _pri.dbgR('!!! missing feature: ' + k + '!');
                    failed.push(k);
                }
            });

            if (failed.length > 0)
            {
                _pri.loadLnk('/live/features_wrap', {failed: failed});
            }
        }

        // // TEST features_wrap ...
        // failed.push('websockets', 'iossafaricheck');
        // _pri.loadLnk('/live/features_wrap', {failed: failed});

        var $wrp_lss = $('#wrp_lss');

        $wrp_lss.find('[data-toggle="tooltip"]').tooltip({
            html: true,
            // container: 'body',
            // trigger: 'click',
            // trigger : 'hover',
            template: '<div class="tooltip nosel mwp-360" role="tooltip"><div class="arrow"></div><div class="tooltip-inner mwp-360 px-3 pt-3 text-left"></div></div>',
            boundary: 'viewport'
        });

        $wrp_lss.find('.ls_card').on('click keyenter keyspace', function(e) {

            e.preventDefault();
            e.stopImmediatePropagation();
            e.stopPropagation();

            // $wrp_lss.find('[data-toggle="tooltip"]').tooltip('hide');
            $wrp_lss.find('[data-toggle="tooltip"]').tooltip('dispose');

            var $this = $(this);
            var lc_id = $this.data('lc_id');
            _pri.loadLcWrp(lc_id);
        });

        _pri.applyStatesMap();

        // check failed to avoid show hide race for wrp_chat_next_date
        if (typeof ret.is_admin === 'boolean' && !ret.is_admin && failed.length == 0)
        {
            _pri.dbg('    handle wrp_chat_next_date ... failed:', failed);
            let $wrp_chat_next_date = $('#wrp_chat_next_date');

            if (_pri.sioc.hasValidStatesMap())
            {
                _pri.showHideLcWrp(_pri.lc_id_cur);
            }
            else
            {
                _pri.queue.show_hide_lcwrp = _pri.lc_id_cur;
            }


            // does work - but lets go with states_map ... for now ...
            //
            // let meta = _pri.sioc.getMeta();
            // meta.ls_id = ret.lc_id;
            // _pri.sioc.getRoomState(meta, function(meta) {
            //     _pri.dbg('>>> getRoomState() meta:', meta);
            //
            //     if (_pri.isObj(meta) && meta.ls_id == _pri.lc_id_cur)
            //     {
            //         _pri.dbg('    yup ls_id is cur ...');
            //         if (typeof meta.room_state !== 'undefined' && (meta.room_state == State.STATE_OK || meta.room_state == State.STATE_EXISTING || meta.room_state == State.STATE_BUSY))
            //         {
            //             $('#wrp_chat').removeClass('d-none');
            //         }
            //         else
            //         {
            //             $('#wrp_chat_next_date').removeClass('d-none');
            //         }
            //     }
            // });
        }

        _pri.page.trigger('live:live_lnk_on_load', ret);
    };

    _pri.showHideLcWrp = function(lc_id)
    {
        _pri.dbgG('*** showHideLcWrp() lc_id:', lc_id, '_pri.lc_id_cur:', _pri.lc_id_cur);

        let sm = _pri.sioc.getStatesMap();

        _pri.dbg('    states_map:', sm);

        if (lc_id != _pri.lc_id_cur || !_pri.isObj(sm))
        {
            return;
        }

        let $wrp_chat_next_date = $('#wrp_chat_next_date');

        if ($wrp_chat_next_date.length > 0)
        {
            if (typeof sm[lc_id] === 'undefined' || (sm[lc_id] != State.STATE_OK && sm[lc_id] != State.STATE_EXISTING && sm[lc_id] != State.STATE_BUSY))
            {
                $('#wrp_chat_next_date').removeClass('d-none');
                $('#chat_pdt_cls').removeClass('d-none');
            }
            else
            {
                $('#wrp_chat').removeClass('d-none');
                $('#chat_pdt_cls').removeClass('d-none');
            }
        }
        else
        {
            if (typeof sm[lc_id] !== 'undefined' && (sm[lc_id] == State.STATE_OK || sm[lc_id] == State.STATE_EXISTING || sm[lc_id] == State.STATE_BUSY))
            {
                $('#wrp_chat').removeClass('d-none');
                $('#chat_pdt_cls').removeClass('d-none');
            }
        }
    };

    _pri.getFeatures = function()
    {
        var iossafaricheck = true;
        var ua = navigator.userAgent;
        var ios = ((/iPad|iPhone|iPod/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) && !window.MSStream);
        if (ios)
        {
            var no_safari = /CriOS/.test(ua) || /FxiOS/.test(ua) || /OPiOS/.test(ua) || /mercury/.test(ua);
            if (no_safari)
            {
                iossafaricheck = false;
            }
        }

        return {
            cookies:          Modernizr.cookies, // but now, again ... // currently used modernizer doesn't has cookie test built in ...!
            websockets:       Modernizr.websockets,
            websocketsbinary: Modernizr.websocketsbinary,
            peerconnection:   Modernizr.peerconnection,
            // datachannel:      true, //Modernizr.datachannel, // obviously not needed, but iOS's Safari stumbles upon it ...
            mediaDevices:     (typeof navigator.mediaDevices.addEventListener === 'function'),
            getusermedia:     Modernizr.getusermedia,
            iossafaricheck:   iossafaricheck
        };
    };

    _pri.pushState = function(ret)
    {
        _pri.dbg('*** pushState() _pri.push_state:', _pri.push_state);

        if (!_pri.push_state)
        {
            _pri.dbg('    toggle only ...');
            _pri.push_state = true;
        }
        else if (typeof ret === 'object' && typeof ret.page_url !== 'undefined' && typeof ret.page_title !== 'undefined')
        {
            _pri.dbg('    push url:', ret.page_url);
            if (!_pri.isObj(window.history.state) || typeof window.history.state.live_url !== 'string' || window.history.state.live_url != ret.page_url)
            {
                _pri.dbgY('    push now ...');
                window.history.pushState({live_url: ret.page_url}, ret.page_title, ret.page_url);
            }
        }
    };

    //################################################################################################################################
    //################################################################################################################################
    //################################################################################################################################

    _pri.initLbb = function()
    {
        _pri.dbg('*** initLbb()');

        _pri.$frm_llb.trigger('ev_form_submit');

        _pri.$sfinps      = $('.sfinp');
        _pri.$s_check     = $('input[name="s__fc__"]');

        _pri.$sfinps.on('change', function(e) {

            var $this = $(this);
            var name  = $this.attr('name');
            _pri.dbgY('*** sfinp on change ... name:', name);

            if (name != 's__fc__' && name != 's__sc__')
            {
                if (name != 's__sc__' && name != 's__vc__' && name != 's_state_sort')
                {
                    // a filter has been added while fc was active -> revert s_txt filter ...

                    if (_pri.$s_check.length != null && _pri.$s_check.prop('checked'))
                    {
                        _pri.$s_txt.val(_pri.s_check_val_buf);
                        _pri.s_txt = _pri.$s_txt.val().trim();
                        _pri.s_check_val_buf = '';

                        _pri.$s_check.prop('checked', false).trigger('change');
                    }
                }

                _pri.$frm_llb.trigger('ev_form_submit');
            }
        });

        // scope filter behaves different ... at least one will be selected ...
        // so stands without any value for this filter won't ever show up ...!
        // to get rid of this, simply comment this block and remove " && name != 's__sc__' " inside the common on change handler above ...
        var $cbs_scopes = $("[id^='s__sc___']");
        $cbs_scopes.on('change', function(e) {
            // _pri.dbg('*** scopes changed');
            var $cb_changed = $(this);
            var checked = 0;
            $.each($cbs_scopes, function() {
                var $this = $(this);
                if ($this.is(':checked'))
                {
                    ++checked;
                    return;
                }
            });
            if (checked == 0)
            {
                $.each($cbs_scopes, function() {
                    var $this = $(this);
                    if ($this.attr('id') != $cb_changed.attr('id'))
                    {
                        $this.prop('checked', true);
                    }
                });
            }
            _pri.$frm_llb.trigger('ev_form_submit');
        });

        _pri.$s_txt = $('#s_txt');
        _pri.s_txt = _pri.$s_txt.val().trim();
        // $s_txt.on('keydown', function() {
        //     ++_pri.req_id;
        // });
        _pri.$s_txt.on('input', function() {
            var $this = $(this);
            _pri.dbg('    s_txt now ...', _pri.$s_txt.val());

            if (_pri.$s_txt.val().trim() != _pri.s_txt)
            {
                if (_pri.$s_check.length != null && _pri.$s_check.prop('checked'))
                {
                    _pri.$s_check.prop('checked', false).trigger('change');
                }

                _pri.s_txt = _pri.$s_txt.val().trim();
                _pri.getLiveChats(++_pri.req_id);
            }
        });
        _pri.$s_txt.on('focus', function(e)
        {
            _pri.$s_txt.trigger('input');
        });
        _pri.page.on('page:clri_click', function(e, o) {
            // _pri.dbg('page:clri_click', o);
            _pri.$s_txt.trigger('input');
        });


        var $tgl_btns = _pri.$frm_llb.find('input[type="checkbox"].btn-tgl');
        _pri.dbg('tgl_btns:', $tgl_btns.length);
        $.each($tgl_btns, function(kelm, velm) {
            JW.BtnTgl(jQuery, velm);
        });

        _pri.$s_geoloc = $('#s_geoloc');
        if (_pri.$s_geoloc.length == 1)
        {
            _pri.$s_lat = $('#s_lat');
            _pri.$s_lng = $('#s_lng');

            _pri.geoloc =
            {
                ll_callid:  '',
                curval:     _pri.$s_geoloc.val()
            };

            _pri.page.on('geoc:set_ll_to_name_done', function(e, o) {
                _pri.dbg('*** on geoc:set_ll_to_name_done', o);

                if (_pri.isObj(o) && typeof o.callid !== 'undefined' && _pri.geoloc.ll_callid == o.callid && typeof o.nm === 'string' && _pri.isObj(o.ll))
                {
                    _pri.geoloc.ll_callid = '';
                    _pri.$s_geoloc.val(o.nm);
                    _pri.$s_lat.val(o.ll.lat);
                    _pri.$s_lng.val(o.ll.lng);

                    _pri.$frm_llb.trigger('ev_form_submit');
                }
            });

            _pri.page.on('geoc:set_ll_to_name_err', function(e, o) {
                _pri.dbg('*** on geoc:set_ll_to_name_err', o);

                if (_pri.isObj(o) && typeof o.callid !== 'undefined' && _pri.geoloc.ll_callid == o.callid)
                {
                    _pri.$s_geoloc.addClass('is-invalid').addAttr('aria-invalid');
                }
            });

            _pri.$s_geoloc.on('blur', function() {
                _pri.dbgG('*** s_geoloc on blur()');

                let val = _pri.$s_geoloc.val();

                if (val != '' && val.length > 1 && val != _pri.geoloc.curval)
                {
                    _pri.dbg('    trigger submit ...');

                    _pri.$s_geoloc.removeClass('is-invalid').removeAttr('aria-invalid');

                    _pri.geoloc.ll_callid = _pri.page.getUId();
                    _pri.geoloc.curval = val;

                    JW.GeoC.getLLToName(val, _pri.geoloc.ll_callid);
                }
            });
        }
        else
        {
            _pri.$s_geoloc = null;
        }

    };

    _pri.onBtnTglClick = function(e, o)
    {
        _pri.dbg('*** onBtnTglClick()');
        _pri.dbg('    o:', o);

        if (typeof o !== 'object' || typeof o.name !== 'string' || typeof o.state !== 'boolean')
        {
            _pri.dbgR('    wrong arguments! - return.');
            return;
        }

        if ($('#frm_llb').length < 1)
        {
            _pri.dbgR('    no lobby form?! - return.');
            return;
        }

        // folder check
        if (o.name == 's__fc__')
        {
            var val = _pri.$s_txt.val();
            if (o.state)
            {
                _pri.s_check_val_buf = val;
                _pri.$s_txt.val(_pri.s_check_val_def);
                _pri.s_txt = _pri.$s_txt.val().trim();
            }
            else
            {
                _pri.$s_txt.val(_pri.s_check_val_buf);
                _pri.s_txt = _pri.$s_txt.val().trim();
                _pri.s_check_val_buf = '';
            }

            _pri.$frm_llb.trigger('ev_form_submit');
        }
    };

    _pri.getLiveChats = function(req_id)
    {
        setTimeout(function() {
            if (req_id == _pri.req_id)
            {
                _pri.$frm_llb.find('#req_id').val(_pri.req_id);
                _pri.$frm_llb.trigger('ev_form_submit');
            }
            else
            {
                _pri.dbg('... cancelled ...');
            }
        }, 400);
    };

    //################################################################################################################################
    //################################################################################################################################
    //################################################################################################################################

    // page links to /live/...
    _pri.liveLnkClick = function(e)
    {
        _pri.dbgG('*** liveLnkClick()');

        e.preventDefault();

        var $this = $(this);
        var href = $this.attr('href');
        let qdata = {};
        let evlo = $this.data('evlo');

        if (typeof href === 'undefined')
        {
            _pri.dbg('    href is undefined, try data-href istead ...');
            href = $this.data('href');
        }

        if (typeof evlo !== 'undefined' && $.isPlainObject(evlo))
        {
            _pri.dbg('    evlo found ...');

            if (typeof evlo.fvals !== 'undefined' && $.isArray(evlo.fvals))
            {
                _pri.dbg('    fvals found ...');

                $.each(evlo.fvals, function(k, v) {

                    _pri.dbg('        ' + k + ': [' + v + ']');

                    var $elm = $('input[name="' + v + '"]');
                    if ($elm.length < 1)
                    {
                        $elm = $('#' + v);
                    }

                    if ($elm.length > 0)
                    {
                        if ($elm.is(':checkbox'))
                        {
                            _pri.dbg('        found checkbox, evaluate v: [' + v + ']');
                            qdata[v] = $elm.prop('checked');
                        }
                        else
                        {
                            _pri.dbg('        found v: [' + v + ']');
                            qdata[v] = $elm.val();
                        }
                    }
                });
            }
        }

        _pri.dbg('    href:', href);
        _pri.dbg('    qdata:', qdata);

        // $('.mdl-mask').trigger('click');
        _pri.$body.trigger('click');
        if ($('#nav-top-sub').hasClass('show'))
        {
            $('#mbtn').trigger('click');
        }

        _pri.loadLnk(href, null, qdata);

        return false;
    };

    _pri.loadLnk = function(href, data_add, qdata)
    {
        _pri.dbg('*** loadLnk() href:', href);

        if (typeof href === 'undefined')
        {
            _pri.dbgR('!!! loadLnk() href is undefined!');
            return false;
        }

        let href_orig = href;
        href = href.replace(/https?:\/\/(?:www\.)?(?:int\.)?azubisprechstunde\.de\/?/i, '/');
        href = href.replace(/https?:\/\/(?:www\.)?(?:int\.)?jobwoche\.de\/?/i, '/');
        href = href.replace(/https?:\/\/(?:www\.)?(?:int\.)?webmessen\.de\/?/i, '/');

        if (href === '/')
        {
            href = '/live/messe';
        }

        let parts = href.split('/');
        _pri.dbg('    parts:', parts);

        if ($.isArray(parts) && parts.length >= 2 && parts[0] == '' && parts[1] == 'live')
        {
            _pri.dbg('    parts is array [ "", "live" [, ...] ]');
            _pri.closeWinLoading();

            if (typeof parts[2] !== 'undefined' && parts[2] == _pri.slug)
            {
                _pri.dbg('    parts[2] == _pri.slug');
                parts = parts.slice(3);
                _pri.dbg('    after slice(3) parts:', parts);
            }
            else
            {
                parts = parts.slice(2);
                _pri.dbg('    after slice(2) parts:', parts);
            }

            _pri.dbg('    parts is array?', $.isArray(parts));
            _pri.dbg('    parts.length:', parts.length);

            if (parts.length == 0 || parts[0] == '')
            {
                // parts.push('lobby');
                parts = ['lobby'];
            }

            let is_lc_id = _pri.rx_lc_id.test(parts[0]);

            _pri.dbgG('     _pri.slug:', _pri.slug);
            _pri.dbg('    parts clean:', parts.join(' | '));
            _pri.dbg('       is_lc_id:', is_lc_id);

            if ($.inArray(parts[0], _pri.lnk_acts) === -1 && !is_lc_id)
            {
                _pri.dbgR('    !!! not my namespace, no common acts - start over ...');

                // _pri.checkLeaveWB();
                window.location.href = href_orig;

                return false;
            }

            if (is_lc_id)
            {
                _pri.dbgG('    lc_id found -> call loadLcWrp()');

                // _pri.checkLeaveWB();
                _pri.loadLcWrp(parts[0]);
            }
            else
            {
                if (!_pri.isObj(qdata))
                {
                    qdata = {};
                }

                let act = '/live/' + parts.join('/');
                _pri.dbg('    act 0:', act);

                let query = '';
                let qdata_act  = {};
                let ix = act.indexOf('?');

                if (ix != -1)
                {
                    query = act.slice(ix + 1);
                    act   = act.slice(0, ix);

                    let params = new URLSearchParams(query);
                    let entries = params.entries();

                    for (const [k, v] of entries)
                    {
                        qdata_act[k] = v;
                    }

                    qdata = $.extend({}, qdata_act, qdata);
                }

                let arr = [];

                $.each(qdata, function(k, v) {
                    // arr.push(encodeURIComponent(k) + "=" + encodeURIComponent(v));
                    arr.push(k.toString() + '=' + v.toString());
                });

                act = act.replace(/\/?$/, '/');
                if (arr.length > 0)
                {
                    query = arr.join('&');
                    act   = act + '?' + query;
                }

                _pri.dbg('    act 1:', act);

                _pri.cont_req = {
                    data: {
                        dataType: 'json',
                        lfair_id: _pri.lfair_id,
                        act: act
                    },
                    url: '/_liveix'
                };

                _pri.dbgG('    act for _liveix:', _pri.cont_req.data.act);

                if (!_pri.isObj(data_add))
                {
                    data_add = {};

                }
                let data = $.extend({}, _pri.cont_req.data, qdata, data_add);

                // _pri.modal.get('/_liveix', data, _pri.modal.handleJSONRet);
                _pri.modalGet('/_liveix', data, _pri.modal.handleJSONRet);
            }
        }
        else
        {
            // window.open(href, '_blank');
            _pri.dbg('    parts is not array or parts.length < 2 or parts[0] != \'\' or parts[1] != live');
            if (parts[1] == '_ajx')
            {
                _pri.dbg('    _ajx ... do nothing here ,,,');
            }
            else
            {
                _pri.dbg('    -> open new tab with:', href_orig);
                window.open(href_orig, '_blank');
            }
        }
















        // var mtc = _pri.rx_load_lnk.exec(href);
        // _pri.dbgG('    mtc:', mtc);
        //
        // if ($.isArray(mtc))
        // {
        //     _pri.dbgG('    mtc.length:', mtc.length);
        //     _pri.dbgG('    _pri.slug:', _pri.slug);
        //     _pri.dbgG('    slug mismatch?', mtc[1] != _pri.slug);
        //     _pri.dbgG('    not subact?', $.inArray(mtc[1], _pri.lnk_acts) === -1);
        //
        //     _pri.closeWinLoading();
        //
        //     if (mtc[1] != _pri.slug && $.inArray(mtc[1], _pri.lnk_acts) === -1)
        //     {
        //         _pri.dbgR('    !!! not my namespace, no common acts - start over ...');
        //
        //         // _pri.checkLeaveWB();
        //         window.location.href = href;
        //
        //         return false;
        //     }
        //
        //     if (typeof mtc[2] !== 'undefined' && _pri.rx_lc_id.test(mtc[2]))
        //     {
        //         _pri.dbgG('    lc_id found -> call loadLcWrp()');
        //
        //         // _pri.checkLeaveWB();
        //         _pri.loadLcWrp(mtc[2]);
        //     }
        //     else
        //     {
        //         _pri.cont_req = {
        //             data: {
        //                 dataType: 'json',
        //                 lfair_id: _pri.lfair_id,
        //                 act:  href
        //             },
        //             url: '/_liveix'
        //         };
        //
        //         var data;
        //         if (typeof data_add === 'object')
        //         {
        //             data = $.extend({}, _pri.cont_req.data, data_add);
        //         }
        //         else
        //         {
        //             data = _pri.cont_req.data;
        //         }
        //
        //         // _pri.modal.get('/_liveix', data, _pri.modal.handleJSONRet);
        //         _pri.modalGet('/_liveix', data, _pri.modal.handleJSONRet);
        //     }
        // }
        // else
        // {
        //     window.open(href, '_blank');
        // }















        // if (false && href == '/live')
        // {
        //     _pri.dbgY('    calling loadLlb()');
        //     _pri.loadLlb();
        // }
        // else
        // {
        //     var arr = _pri.rx_lc_lnk.exec(href);
        //     _pri.dbg('    exec:', arr);
        //     if (arr && arr.length == 2)
        //     {
        //         _pri.loadLcWrp(arr[1]);
        //     }
        //     else
        //     {
        //         _pri.cont_req = {
        //             data: {
        //                 dataType: 'json',
        //                 lfair_id: _pri.lfair_id,
        //                 act:  href
        //             },
        //             url: '/_liveix'
        //         };
        //
        //         var data;
        //         if (typeof data_add === 'object')
        //         {
        //             data = $.extend({}, _pri.cont_req.data, data_add);
        //         }
        //         else
        //         {
        //             data = _pri.cont_req.data;
        //         }
        //
        //         _pri.modal.get('/_liveix', data, _pri.modal.handleJSONRet);
        //     }
        // }
    };

    _pri.lcAdminLnkClick = function(e)
    {
        var cnt = 0;

        if (typeof e === 'number')
        {
            cnt = ++e;
        }
        else
        {
            e.preventDefault();
        }

        _pri.dbg('*** lcAdminLnkClick()');

        var auth_state = _pri.sioc.getAuthState();
        if (auth_state != State.STATE_OK)
        {
            _pri.dbg('    !!! auth_state [' + auth_state + ']!.');

            if (cnt < 5 && auth_state == State.STATE_ERR_NO_INIT)
            {
                _pri.modal.setMask(1, 1, 1);
                _pri.dbg('    [' + cnt + '] will try again ...');
                setTimeout(function() {
                    _pri.lcAdminLnkClick(cnt);
                }, 1000);
            }
            else
            {
                _pri.modal.showMsg(_pri.cookie_msg, '', 'mwp-360');
            }

            return false;
        }

        var $this = $(this);
        var lc_id = $this.data('lc_id');
        var room_id = _pri.sioc.getRoomIdByLcId(lc_id);
        var display_name = $('#inp_dnm').val();

        _pri.enterRoomAdm({
            room_id_to:   room_id,
            display_name: display_name
        });

        return false;
    };

    _pri.showWinLoading = function()
    {
        // status win ...
        _pri.dbgY('    show status win ...');
        _pri.modal.setMask(1, 1, 0);
        var status_tpl    = _pri.sioc.getTpl('live_knock_status');
        var status_win    = status_tpl.replace(/\{HEADLINE\}/g, 'Einen Moment bitte ...')
                                      .replace(/\{MSG_TXT\}/g, '<div>Bitte warten Sie, bis die Verbindung hergestellt wurde.</div><div id="queue_pos" class="text-danger">Position in der Warteschlange: <b>1</b></div>');

        _pri.win_loading_id = 'live_knock_status' + _pri.page.getUId();
        var $win = $(status_win).attr('id', _pri.win_loading_id);
        $win.find('.live-ok').on('click', function(e) {
            e.preventDefault();
            _pri.modal.closeWin(_pri.win_loading_id);
        });
        _pri.modal.showMsgWin($win, _pri.win_loading_id);
        // _pri.modal.dragEl('#' + _pri.win_loading_id); // commented in modal ... for now ...
    };

    _pri.updWinLoading = function(step)
    {
        var $win = $('#' + _pri.win_loading_id);
        if ($win.length == 1)
        {
            switch (step)
            {
                case 'knock_response':

                    $win.find('.main-body').html('<div>Sie werden jetzt verbunden.</div><div>Bitte haben Sie noch einen kurzen Augenblick Geduld.</div>');

                break;

                case 'on_wm_ready':

                    $win.find('.mdl-header').addClass('bg-primary');
                    $win.find('.mdl-header > h3').html('Los geht\'s!');
                    // // $win.find('.main-body').html('<div>Ihre Verbindung wurde hergestellt und wird jetzt kurz optimiert.</div><div class="text-danger">Bitte beachten Sie möglicherweise angezeigte Hinweise und folgen Sie deren Anweisungen.</div><div>Danach stehen Ihnen unsere Mitarbeiter für ein Gespräch zur Verfügung.</div>');
                    // $win.find('.main-body').html('<div>Klicken Sie bitte jetzt auf <span class="nwrap">Erlaubnis anfragen</span>.</div><div>Anschließend erlauben Sie den Zugriff auf Kamera und Mikrofon.</div>');
                    // // var $btn = $('<div class="mdl-body"><button class="btn btn-secondary btn-block rpl mdl-close">Schließen</button></div>');
                    // // $win.append($btn);

                    // $win.find('.main-body').html('<div>Ihre Verbindung wurde hergestellt und wird jetzt kurz optimiert.</div><div class="text-danger">Bitte beachten Sie möglicherweise angezeigte Hinweise und folgen Sie deren Anweisungen.</div><div>Danach stehen Ihnen unsere Mitarbeiter für ein Gespräch zur Verfügung.</div>');
                    $win.find('.main-body').html('<div class="h4 m-0 p-0 text-primary">Wir wünschen Ihnen viel Erfolg!</div>');
                    $win.find('.wrp_btn > .btn').removeClass('op0 cud').addClass('mdl-close').focus();

                    setTimeout(function() {
                        _pri.closeWinLoading();
                    }, 2000);

                break;

                case 'on_wm_participantupdate':

                    $win.find('.main-body').html('<div class="h4 m-0 p-0 text-primary">Wir wünschen Ihnen viel Erfolg!</div>');

                    setTimeout(function() {
                        _pri.closeWinLoading();
                    }, 2000);

                break;

                default:

                break;
            }
        }
    };

    _pri.closeWinLoading = function()
    {
        if (_pri.win_loading_id != '')
        {
            _pri.modal.setMask(0, 0, 0);
            _pri.modal.closeWin(_pri.win_loading_id);
            _pri.win_loading_id = '';
        }
    };

    _pri.onWindowMsg = function(e, oe)
    {
        _pri.dbgG('*** onWindowMsg() oe:', oe);
        _pri.dbgB('    0');

        if (typeof oe === 'object' && typeof oe.data === 'object' && typeof oe.data.type === 'string' && typeof oe.origin === 'string' && oe.origin == 'https://jobwoche.whereby.com' && _pri.lc_id_cur > 0)
        {
            _pri.dbgB('    1 whereby window message ...');

            if (oe.data.type == 'ready')
            {
                _pri.dbgB('    2 ready');
                _pri.updWinLoading('on_wm_ready');
                _pri.got_wm_ready = true;
            }
            else if (oe.data.type == 'participantupdate')
            {
                _pri.dbgB('    3 participantupdate');

                if (_pri.got_wm_ready)
                {
                    _pri.got_wm_ready = false;
                    _pri.got_wm_pu    = true;


                    _pri.updWinLoading('on_wm_participantupdate');
                    _pri.dbgB('    ################ CALL /_wbc');
                    $.ajax({
                        type: "POST",
                        url: '/_wbc',
                        data: {
                            ls_id: _pri.lc_id_cur,
                            eid: _pri.sioc.getEId(),
                            cid: _pri.sioc.getCid(),
                            act: 1
                        },
                        dataType: 'json'
                    }).done(function(ret, stat_str, jq_xhr) {
                        _pri.dbgB('    ################## DONE ret:', ret);
                    });
                }
                else
                {
                    _pri.dbgB('    ... not me ...');
                }
            }
            else
            {
                _pri.dbgR('    5 unknown message type?');
                _pri.closeWinLoading();
            }
        }
        else
        {
            _pri.dbgR('    6 unknown window message!');
        }

        // var $win = $('#' + _pri.win_loading_id);
        // if ($win.length == 1)
        // {
        //     _pri.dbgB('    1 win loading ... me');
        //     if (typeof oe === 'object' && typeof oe.data === 'object' && typeof oe.data.type === 'string' && typeof oe.origin === 'string' && oe.origin == 'https://jobwoche.whereby.com')
        //     {
        //         _pri.dbgB('    2 whereby window message ...');
        //
        //         if (oe.data.type == 'ready')
        //         {
        //             _pri.dbgB('    3 ready');
        //             _pri.updWinLoading('on_wm_ready');
        //         }
        //         else if (oe.data.type == 'participantupdate')
        //         {
        //             _pri.dbgB('    4 participantupdate');
        //             _pri.updWinLoading('on_wm_participantupdate');
        //             _pri.dbgB('    ################ CALL /_wbc');
        //             $.ajax({
        //                 type: "POST",
        //                 url: '/_wbc',
        //                 data: {
        //                     ls_id: _pri.lc_id_cur,
        //                     eid: _pri.sioc.getEId()
        //                 },
        //                 dataType: 'json'
        //             }).done(function(ret, stat_str, jq_xhr) {
        //                 _pri.dbgB('    ################## DONE ret:', ret);
        //             });
        //         }
        //         else
        //         {
        //             _pri.dbgR('    5 unknown message type?');
        //             _pri.closeWinLoading();
        //         }
        //     }
        //     else
        //     {
        //         _pri.dbgR('    6 unknown window message!');
        //         _pri.closeWinLoading();
        //     }
        // }
        // else
        // {
        //     _pri.dbgB('    000 not me ...');
        // }
    };

    _pri.lcVisitorLnkClick = function(e)
    {
        _pri.dbgG('*** lcVisitorLnkClick()');

        var cnt = 0;

        if (typeof e === 'number')
        {
            cnt = ++e;
        }
        else if (typeof e === 'object')
        {
            e.preventDefault();

            $('#lc_visitor_lnk').addClass('nosel');
            $('#lc_visitor_lnk').html('Anfrage läuft ...<i class="fa fa-refresh fa-spin fa-fw ml-2"></i>');
            $('#inp_dnm').removeClass('border border-danger');
            $('#wrp_msg').html('&nbsp;');
        }

        var auth_state = _pri.sioc.getAuthState();
        if (auth_state != State.STATE_OK)
        {
            _pri.dbg('    !!! auth_state [' + auth_state + ']!.');

            if (cnt < 5 && auth_state == State.STATE_ERR_NO_INIT)
            {
                _pri.modal.setMask(1, 1, 1);
                _pri.dbg('    [' + cnt + '] will try again ...');
                setTimeout(function() {
                    _pri.lcVisitorLnkClick(cnt);
                }, 1000);
            }
            else
            {
                $('#lc_visitor_lnk').removeClass('nosel');
                $('#lc_visitor_lnk').html('Weiter');
                _pri.modal.showMsg(_pri.cookie_msg, '', 'mwp-360');
            }

            return false;
        }

        _pri.modal.setMask(0, 0, 0);

        var $this = $('#lc_visitor_lnk');
        var lc_id = $this.data('lc_id');

        if (!_pri.rx_lc_id.test(lc_id))
        {
            $('#inp_dnm').addClass('border border-danger');
            $('#wrp_msg').html('<span class="d-block badge badge-danger w-100 py-1 mt-1">Leider ist ein Fehler aufgetreten.<br>Bitte versuchen Sie es später noch einmal.</span>');
            $('#lc_visitor_lnk').removeClass('nosel');
            $('#lc_visitor_lnk').html('Weiter');
            return false;
        }

        var display_name = $('#inp_dnm').val().trim();
        $('#inp_dnm').val(display_name);

        if (!_pri.sioc.validateDisplayName(display_name))
        {
            _pri.dbgR('!!! display name not valid!');

            $('#inp_dnm').addClass('border border-danger');
            $('#wrp_msg').html('<span class="d-block badge badge-danger w-100 py-1 mt-1">Bitte überprüfen Sie den Chat-Namen.</span>');
            $('#lc_visitor_lnk').removeClass('nosel');
            $('#lc_visitor_lnk').html('Weiter');
            return false;
        }

        var meta0 = _pri.sioc.getMeta();
        meta0.act_from          = 'knock';
        meta0.display_name_from = display_name;
        meta0.lc_id_to          = lc_id;
        meta0.room_id_to        = _pri.sioc.getRoomIdByLcId(lc_id);

        if (typeof _pri.cmp_names_map[lc_id] !== 'undefined')
        {
            meta0.cmp_name_to = _pri.cmp_names_map[lc_id];
        }
        else
        {
            _pri.dbgR('!!! Unknown cmp_name!? ...');
            meta0.cmp_name_to = '';
        }

        _pri.showWinLoading();


        _pri.sioc.knock(meta0, function(meta) {

            _pri.dbg('*** knock()', meta);

            // _pri.modal.closeWin();

            var lc_id    = meta.lc_id_to;
            var cmp_name = meta.cmp_name_to;

            if (meta.state === State.STATE_OK)
            {
                if (_pri.lc_id_cur == lc_id)
                {
                    $('#lc_visitor_lnk').addClass('op0');
                    $('#lc_visitor_lnk').removeClass('nosel');
                    $('#lc_visitor_lnk').html('Weiter');

                    _pri.enterRoomVis({
                        lc_id:      lc_id,
                        user_name:  display_name
                    });

                    // _pri.roomObserver = _pri.observeRoom(lc_id);
                    // _pri.observe_lc_id = lc_id;
                    //
                    // _pri.cont_req = {
                    //     data: {
                    //         dataType: 'json',
                    //         lc_id: lc_id,
                    //         display_name: display_name
                    //     },
                    //     url: '/_lcvis'
                    // };
                    //
                    // _pri.modal.get('/_lcvis', _pri.cont_req.data, _pri.modal.handleJSONRet);

                    _pri.updWinLoading('knock_response');
                }
                else
                {
                    _pri.modal.closeWin(_pri.win_loading_id);

                    if (cmp_name == '')
                    {
                        cmp_name = 'Messestand';
                    }

                    var tpl = _pri.sioc.getTpl('live_knock_confirm');
                    var win  = tpl.replace(/\{CMP_NAME\}/g, cmp_name);
                    var win_id = 'live_knock_confirm' + _pri.page.getUId();
                    var $win = $(win).attr('id', win_id);
                    $win.find('.live-ok').on('click', function(e) {
                        e.preventDefault();
                        _pri.modal.closeWin(win_id);
                        _pri.loadLcWrp(lc_id);
                    });
                    _pri.modal.showMsgWin($win, win_id);
                }
            }
            else if (meta.state === State.STATE_BUSY)
            {
                _pri.modal.closeWin(_pri.win_loading_id);

                if (_pri.lc_id_cur == lc_id)
                {
                    $('#lc_visitor_lnk').removeClass('nosel');
                    $('#lc_visitor_lnk').html('Erneut anklopfen');
                }

                var hdl = cmp_name;
                if (cmp_name == '')
                {
                    hdl = 'Hinweis';
                }

                var tpl = _pri.sioc.getTpl('live_knock_busy');
                var win  = tpl.replace(/\{CMP_NAME\}/g, hdl);
                var win_id = 'live_knock_busy' + _pri.page.getUId();
                var $win = $(win).attr('id', win_id);
                $win.find('.live-ok').on('click', function(e) {
                    e.preventDefault();
                    // _pri.modal.closeWin(win_id);
                    $win.remove();
                    _pri.modal.setMask(1, 1, 1);
                    _pri.addWaiting(lc_id);
                });
                _pri.modal.showMsgWin($win, win_id);
            }
            else if (meta.state === State.STATE_TRY_AGAIN || meta.state === State.STATE_INFO) // STATE_INFO // not used anymore for now ...
            {
                _pri.modal.closeWin(_pri.win_loading_id);

                if (_pri.lc_id_cur == lc_id)
                {
                    $('#lc_visitor_lnk').removeClass('nosel');
                    $('#lc_visitor_lnk').html('Erneut anklopfen');
                }

                var msg = '';

                if (cmp_name != '')
                {
                    msg += '<p>von: ' + _pri.cmp_names_map[lc_id] + '</p>';
                }

                if (typeof meta.admin_msg !== 'undefined' && meta.admin_msg != '')
                {
                    msg += meta.admin_msg;
                }
                else if (meta.state === State.STATE_TRY_AGAIN)
                {
                    msg += '<p>Einen Moment bitte. Wir sind auf dem Weg ...</p>Bitte versuchen Sie es in Kürze gleich noch einmal.';
                }
                else
                {
                    msg += 'Dieser Messestand ist zur Zeit beschäftigt. Bitte versuchen Sie es später noch einmal.';
                }

                _pri.modal.showMsg(msg, 'Antwort', 'mwp-360');
            }
            else if (meta.state === State.STATE_NOT_FOUND)
            {
                _pri.dbg('    ... admin not found ...');

                _pri.modal.closeWin(_pri.win_loading_id);

                if (_pri.lc_id_cur == lc_id)
                {
                    $('#lc_visitor_lnk').removeClass('nosel');
                    $('#lc_visitor_lnk').html('Erneut anklopfen');
                }

                var msg = '';
                if (cmp_name != '')
                {
                    msg += '<p>' + _pri.cmp_names_map[lc_id] + '</p>';
                }
                msg += 'Dieser Messestand ist zur Zeit nicht verfügbar. Bitte versuchen Sie es später noch einmal.';
                _pri.modal.showMsg(msg, 'Hinweis', 'mwp-360');
            }
            else
            {
                _pri.modal.closeWin(_pri.win_loading_id);

                if (_pri.lc_id_cur == lc_id)
                {
                    $('#lc_visitor_lnk').removeClass('nosel');
                    $('#lc_visitor_lnk').html('Erneut anklopfen');
                }

                _pri.dbgB('    ... some strange error occurred ...');

                var msg = '';
                if (cmp_name != '')
                {
                    msg += '<p>' + _pri.cmp_names_map[lc_id] + '</p>';
                }
                msg += 'Dieser Messestand ist zur Zeit nicht verfügbar. Bitte versuchen Sie es später noch einmal.';
                _pri.modal.showMsg(msg, 'Hinweis', 'mwp-360');
            }
        });

        return false;
    };

    publ.enterRoom = function(meta)
    {
        _pri.dbg('*** enterRoom()');

        if (_pri.lc_id_cur == meta.lc_id)
        {
            _pri.enterRoomVis(meta);
        }
        else
        {
            meta.go = 'vis';
            _pri.loadLcWrp(meta.lc_id, meta);
        }
    };

    _pri.enterRoomVis = function(meta)
    {
        _pri.dbgG('*** enterRoomVis() - assuming all checks have been done before ...');

        _pri.roomObserver = _pri.observeRoom(meta.lc_id);
        _pri.observe_lc_id = meta.lc_id;

        _pri.cont_req = {
            data: {
                dataType: 'json',
                lfair_id: _pri.lfair_id,
                lc_id: meta.lc_id,
                display_name: meta.user_name
            },
            url: '/_lcvis'
        };

        // _pri.modal.get('/_lcvis', _pri.cont_req.data, _pri.modal.handleJSONRet);
        _pri.modalGet('/_lcvis', _pri.cont_req.data, _pri.modal.handleJSONRet);
    };

    _pri.enterRoomAdm = function(meta)
    {
        _pri.dbgG('*** enterRoomAdm() - last checks before enter ...');

        $('#wrp_msg').html('&nbsp;');

        var ec = 0;
        var lc_id = _pri.sioc.getLcIdByRoomId(meta.room_id_to);

        if (ec === 0)
        {
            // we have to be within lc_wrp with corresponding data lc_id and admin
            var $wrp_chat = $('#wrp_chat');
            if (!$wrp_chat.data('admin'))
            {
                _pri.dbgR('    !!! no data admin!?');
                ec = 1;
            }
        }

        if (ec === 0)
        {
            if ($wrp_chat.data('lc_id') != lc_id)
            {
                _pri.dbgR('    !!! data.lc_id != lc_id!?');
                ec = 2;
            }
        }

        if (ec === 0)
        {
            if (!_pri.sioc.validateDisplayName(meta.display_name))
            {
                _pri.dbgR('    !!! display name not valid!');

                $('#inp_dnm').addClass('border border-danger');
                $('#wrp_msg').html('<span class="d-block badge badge-danger w-100 py-1 mt-1">Bitte überprüfen Sie den Chat-Namen.</span>');
                $('#lc_admin_lnk').removeClass('nosel');
                ec = 3;
            }
        }

        // further checks will be done by sioc -> sios ... later again by _lcadm and finally sios.room_join ...

        if (ec !== 0)
        {
            _pri.modal.setMask(0, 0, 0);
            return;
        }

        meta.state = State.STATE_OK;

        _pri.sioc.checkRoomAdm(meta, function(meta) {

            _pri.dbgG('*** cb for sioc.checkRoomAdm() meta:', meta);

            if (meta.state == State.STATE_OK)
            {
                _pri.dbgG('    cb OK go ...');

                _pri.roomObserver = _pri.observeRoom(lc_id);
                _pri.observe_lc_id = lc_id;

                _pri.cont_req = {
                    data: {
                        dataType: 'json',
                        lfair_id: _pri.lfair_id,
                        lc_id: lc_id,
                        display_name: meta.display_name
                    },
                    url: '/_lcadm'
                };

                // _pri.modal.get('/_lcadm', _pri.cont_req.data, _pri.modal.handleJSONRet);
                _pri.modalGet('/_lcadm', _pri.cont_req.data, _pri.modal.handleJSONRet);
            }
            else
            {
                _pri.dbgR('    cb ERR handle ...');

                _pri.modal.setMask(0, 0, 0);
                publ.onRoomJoinErr(meta, false);
            }
        });

    };

    _pri.addWaiting = function(lc_id)
    {
        _pri.sioc.addWaiting(_pri.sioc.getRoomIdByLcId(lc_id), function(meta) {

            _pri.dbgY('--> addWaiting() meta:', meta);

            _pri.modal.setMask(-1, 0, -1);

            var msg;

            if (typeof meta === 'object')
            {
                if (meta.state === State.STATE_OK)
                {
                    msg = 'Sie wurden erfolgreich in die Warteliste eingetragen.<br><br>Sobald Sie an der Reihe sind, werden Sie in den Raum eingeladen.';
                }
                else
                {
                    // STATE_EXISTING
                    msg = 'Sie hatten sich bereits in die Warteliste eingetragen.<br><br>Sobald Sie an der Reihe sind, werden Sie in den Raum eingeladen.';
                }

            }
            else
            {
                msg = 'Leider ist beim Entrag in die Warteliste ein Fehler aufgetreten. Bitte versuchen Sie es später noch einmal.';
            }

            _pri.modal.showMsg(msg, 'Hinweis', 'mwp-360');
        })
    };

    _pri.observeRoom = function(lc_id)
    {
        var elm_id = 'wb_iframe_' + lc_id.toString();

        _pri.dbg('    elm_id:', elm_id);

        var exists = document.getElementById(elm_id) == null ? false : true;

        var observer = new MutationObserver(function(mutations) {

            _pri.dbg('*** observer(' + elm_id + '):', (document.getElementById(elm_id) == null ? false : true));

            if (document.getElementById(elm_id) != null)
            {
                if (!exists)
                {
                    _pri.dbg('    element inserted');
                }
                exists = true;
            }
            else if (exists)
            {
                exists = false;
                _pri.dbg('    element removed');
                // observer.disconnect();
                // call leaveRoom in a function ...
                _pri.cancelRoomObserver();
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });

        return observer;
    };

    _pri.cancelRoomObserver = function()
    {
        if (_pri.roomObserver !== null && typeof _pri.roomObserver !== 'undefined')
        {
            _pri.roomObserver.disconnect();
        }
        _pri.roomObserver = null;
        _pri.sioc.leaveRoom(_pri.sioc.getRoomIdByLcId(_pri.observe_lc_id));
        _pri.observe_lc_id = '';
    };

    _pri.observeWin = function(win, lc_id)
    {
        _pri.dbg('*** observeWin() lc_id:', lc_id, '...');
        _pri.observe_lc_id = lc_id;
        _pri.observe_win_id = setInterval(function() {
            if (win.closed)
            {
                _pri.dbgR('*** observeWin() - ext win closed ...');
                clearInterval(_pri.observe_win_id);
                _pri.observe_win_id = 0;
                _pri.sioc.leaveRoom(_pri.sioc.getRoomIdByLcId(_pri.observe_lc_id));
                _pri.modal.closeWin(_pri.win_ext_win_id);
                _pri.modal.setMask(0, 0, 0);
                _pri.loadLcWrp(_pri.observe_lc_id);
                _pri.observe_lc_id = '';
            }
        }, 1000);
    };

    _pri.lcAdmVisOnLoad = function(e, ret)
    {
        _pri.dbg('*** lcAdmVisOnLoad()', ret, (document.getElementById('wb_iframe_' + ret.lc_id) == null ? false : true));
        _pri.dbgY('    isPhone()?', _pri.page.isPhone());

        if (_pri.page.isPhone())
        {
            if (_pri.$style_elm == null)
            {
                _pri.scaleChatClick();
            }
        }

        if (ret.state == 1)
        {
            var meta          = _pri.sioc.getMeta();
            meta.room_id_to   = _pri.sioc.getRoomIdByLcId(ret.lc_id);
            meta.display_name = ret.display_name;
            _pri.sioc.joinRoom(meta);
        }
        else
        {
            if (_pri.roomObserver != null)
            {
                _pri.cancelRoomObserver();
            }
        }
    };

    _pri.extLnkClick = function(e)
    {
        e.preventDefault();

        _pri.dbgG('*** extLnkClick()');

        if (_pri.roomObserver != null)
        {
            _pri.roomObserver.disconnect();
            _pri.roomObserver = null;
            _pri.observe_lc_id = '';
        }

        var $this = $(this);
        var href = $this.data('href');
        var lc_id = $this.data('lc_id');

        // var ext_loop = setInterval(function() {
        //     if (winObj.closed) {
        //         clearInterval(ext_loop);
        //         _pri.dbgR('ext win closed ...');
        //     }
        // }, 1000);
        var win = window.open(href);
        if (win)
        {
            _pri.dbg('    yup, got win object ...');
            _pri.observeWin(win, lc_id);

            var tpl = _pri.sioc.getTpl(_pri.win_ext_win_id);
            _pri.modal.showMsgWin($(tpl), _pri.win_ext_win_id);
            _pri.modal.setMask(1, 1, 0);
        }
    };

    _pri.onModalLoggedIn = function(e, o)
    {
        _pri.dbg('*** onModalLoggedIn()');
        if (_pri.cont_req != null && _pri.cont_req.url == '/_lc_wrp')
        {
            // _pri.modal.get('/_lc_wrp', _pri.cont_req.data, _pri.modal.handleJSONRet);
            _pri.modalGet('/_lc_wrp', _pri.cont_req.data, _pri.modal.handleJSONRet);
        }
    };

    // not used for now - leaves will be counted by sios ...
    // _pri.checkLeaveWB = function()
    // {
    //     if (_pri.got_wm_pu)
    //     {
    //         _pri.got_wm_pu = false;
    //
    //         _pri.dbgB('    ################ CALL /_wbc');
    //         $.ajax({
    //             type: "POST",
    //             url: '/_wbc',
    //             data: {
    //                 ls_id: _pri.lc_id_cur,
    //                 eid: _pri.sioc.getEId(),
    //                 act: 0
    //             },
    //             dataType: 'json'
    //         }).done(function(ret, stat_str, jq_xhr) {
    //             _pri.dbgB('    ################## DONE ret:', ret);
    //         });
    //     }
    // };

    _pri.modalGet = function(url, data, cbf)
    {
        // _pri.checkLeaveWB();

        _pri.modal.get(url, data, cbf);
    };

    // _pri.test1 = function(e)
    // {
    //     _pri.dbg('******** test1()');
    //     // var co = {
    //     //     '_url': _pri.opts.urls.test,
    //     //     '_msk': false,
    //     //     '_dtp': 'HTML',
    //     //     '_tgt': '#tgt',
    //     //     '_$elm': $(this)
    //     // };
    //     //
    //     // _pri.dbg('test', co);
    //     //
    //     // _pri.modal.cll(co);
    //
    //     // var ili = _pri.sioc.isLoggedIn();
    //     // _pri.dbg('    ili:', ili);
    //
    //     _pri.sioc.getRoomStatus('live3', function(ret) {
    //         _pri.dbg('*** getRoomStatus()', ret);
    //     });
    //
    //     _pri.sioc.knock({}, function(ret) {
    //         _pri.dbg('*** knock()', ret);
    //     });
    // };

    _pri.setUserList = function(e)
    {
        // e.preventDefault();

        _pri.dbg('*** dd_user_list on click ...');

        var list = _pri.sioc.getUserListMenu(_pri.sioc.getRoomIdByLcId(_pri.lc_id_cur));
        _pri.dbg('    list:', list);
        $('#dd_user_list > .dropdown-menu').html(list);
        $('#dd_kick_list > .dropdown-menu').html(list);

        // var $this = $(this);
        // $this.dropdown('update');
        // $this.dropdown('toggle');
    };

    _pri.ddUserClick = function(e)
    {
        e.preventDefault();

        _pri.dbg('*** ddUserClick()');

        var $this = $(this);
        var sid   = $this.data('sid');
        var unm   = $this.data('unm');
        var type  = $this.parent().attr('aria-labelledby');

        _pri.dbg('    type:', type);

        if (typeof sid !== 'undefined' && typeof unm !== 'undefined')
        {
            _pri.dbg('    sid:' + sid);

            $('#' + type + ' > a.btn-chat').dropdown('toggle');

            if (type == 'dd_user_list')
            {
                _pri.sioc.startSS(_pri.sioc.getRoomIdByLcId(_pri.lc_id_cur), sid, unm);
            }
            else if (type == 'dd_kick_list')
            {
                var meta = {
                    lc_id:     _pri.lc_id_cur,
                    sid_to:    sid,
                    user_name: unm
                };
                _pri.sioc.kickUser(meta);
            }
            else if (type == 'dd_waitings_list')
            {
                var meta = {
                    lc_id:        _pri.lc_id_cur,
                    room_id_from: _pri.sioc.getRoomIdByLcId(_pri.lc_id_cur),
                    sid_to:       sid,
                    user_name:    unm,
                    cmp_name:     _pri.cmp_names_map[_pri.lc_id_cur]
                };

                _pri.sioc.inviteUser(meta, function(meta) {

                    _pri.dbg('>>> inviteUser()', meta);

                    if (typeof meta === 'object')
                    {
                        if (meta.state == State.STATE_NONE)
                        {
                            _pri.modal.showMsg('<em>' + _pri.encodeHTML(meta.user_name) + '</em> ist zur Zeit nicht verfügbar. Bitte versuchen Sie es später noch einmal.', '', 'mwp-360');
                        }
                        else if (meta.state == State.STATE_MAX)
                        {
                            _pri.modal.showMsg('Die maximale Anzahl von <em>' + meta.mx_user_cnt + ' Personen</em> in diesem Raum ist bereits erreicht.', '', 'mwp-360');
                        }
                        else if (meta.state == State.STATE_REJECT)
                        {
                            _pri.modal.showMsg('<em>' + _pri.encodeHTML(meta.user_name) + '</em> ist zur Zeit anderweitig beschäftigt.', '', 'mwp-360');
                        }
                        else if (meta.state == State.STATE_NOT_FOUND || meta.state == State.STATE_ERR)
                        {
                            _pri.modal.showMsg('<em>' + _pri.encodeHTML(meta.user_name) + '</em> ist zur Zeit nicht erreichbar.', '', 'mwp-360');
                        }
                    }

                });
            }
        }

        return false;
    };

    _pri.setWaitingsList = function(e)
    {
        _pri.dbg('*** dd_waitings_list on click ...');

        var $this = $(this);
        var $btn  = $('#dd_waitings_list > a.btn-chat');
        if ($btn.attr('aria-expanded') == 'true')
        {
            _pri.dbgB('TRUE');
        }
        else
        {
            var $menu = $('#dd_waitings_list > .dropdown-menu');
            $menu.html('<li class="text-center"><i class="fa fa-refresh fa-spin fa-fw text-secondary"></i></li>');

            _pri.sioc.getWaitingsList(_pri.sioc.getRoomIdByLcId(_pri.lc_id_cur), function(ret) {

                _pri.dbg('--> getWaitingsList cb ret:', ret);

                if (ret.state === State.STATE_OK && typeof ret.waitings_list === 'object')
                {
                    // _pri.dbg('    ok ...');
                    var list = '';
                    var len = Object.keys(ret.waitings_list).length;

                    if (len > 0)
                    {
                        $.each(ret.waitings_list, function(k, v) {
                            list += '<a class="dropdown-item dd_user cup" href="" data-unm="' + v + '" data-sid="' + k + '">' + _pri.encodeHTML(v) + '</a>';
                        });
                    }
                    else
                    {
                        list += '<a class="dropdown-item text-muted nosel" href="">z.Z. keine Einträge</a>';
                    }

                    $('#dd_waitings_list > .dropdown-menu').html(list);
                }

            });
        }
    };

    _pri.onRoomJoinedAdm = function(e, meta)
    {
        _pri.dbg('*** onRoomJoinedAdm() meta:', meta);

        if (typeof meta.locked !== 'undefined')
        {
            _pri.setBusyChatBtn(meta.locked);
        }
    };

    _pri.onLobbyMsg = function(e, meta)
    {
        _pri.dbgG('*** onLobbyMsg() meta:', meta);
        _pri.dbg('    lc_id_cur: ', _pri.lc_id_cur, '_pri.lfair_id:', _pri.lfair_id);

        if (typeof meta.lobbymsg !== 'object')
        {
            return;
        }

        if (meta.lobbymsg.msg_fair_id != '0' && meta.lobbymsg.msg_fair_id != _pri.lfair_id)
        {
            _pri.dbg('    msg for different fair_id ...');
            return;
        }

        if (!meta.lobbymsg.msg_at_rooms && _pri.lc_id_cur != 0)
        {
            _pri.dbg('    not in lobby - return.');
            return;
        }

        if (_pri.modal.hasMask())
        {
            _pri.dbg('    mask still open - return.');
            return;
        }

        var tpl = _pri.sioc.getTpl('live_lobbymsg');
        var win  = tpl.replace(/\{MSG_HDL\}/g, meta.lobbymsg.msg_hdl).replace(/\{MSG_TXT\}/g, meta.lobbymsg.msg_txt);
        var win_id = 'live_lobbymsg' + _pri.page.getUId();
        var $win = $(win).attr('id', win_id);
        var $btn_lnk = $win.find('#lobbymsg_room_link');

        if (meta.lobbymsg.msg_lnk_room_id != '')
        {
            $win.find('#lobbymsg_room_link').on('click', function(e) {

                e.preventDefault();
                var lc_id = _pri.sioc.getLcIdByRoomId(meta.lobbymsg.msg_lnk_room_id);

                _pri.loadLcWrp(lc_id);
            });
        }
        else
        {
            $btn_lnk.remove();
        }

        _pri.modal.showMsgWin($win, win_id);
    };

    _pri.onStatesMap = function(e, meta)
    {
        _pri.dbgG('*** onStatesMap() meta:', meta);
        _pri.dbg('    lc_id_cur: ', _pri.lc_id_cur);

        // if (_pri.lc_id_cur != 0)
        // {
        //     _pri.dbg('    not in lobby - return.');
        //     return;
        // }
        //
        if (meta.state == State.STATE_OK && typeof meta.states_map === 'object' && meta.states_map != null)
        {
            _pri.applyStatesMap();
            if (_pri.queue.show_hide_lcwrp != 0)
            {
                _pri.showHideLcWrp(_pri.queue.show_hide_lcwrp);
                _pri.queue.show_hide_lcwrp = 0;
            }
        }
    };

    _pri.applyStatesMap = function()
    {
        let $wrps = $('.wrp_ls_vc');

        if ($wrps.length == 0)
        {
            return;
        }

        _pri.dbgG('*** applyStatesMap()');

        let sm = _pri.sioc.getStatesMap();
        // _pri.dbg('    sioc.states_map:', sm);

        if (_pri.isObj(sm))
        {
            // _pri.dbg('    states_map:', sm);

            // $.each(sm, function (k, v) {
            //     let cls;
            //     if (v == State.STATE_OK)
            //     {
            //         cls = 'state1';
            //     }
            //     else if (v == State.STATE_BUSY)
            //     {
            //         cls = 'state2';
            //     }
            //     else
            //     {
            //         // STATE_ERR  ... room error
            //         // STATE_NONE ... no admin
            //         cls = 'state3';
            //     }
            //
            //     // _pri.dbg('    cls:', cls);
            //
            //     $('#card_ls_' + k).removeClass('state1 state2 state3').addClass(cls);
            // });

            let states_map = $.extend({}, sm);

            let $wrp_lss  = $('#wrp_lss');
            let ls_childs = $wrp_lss.data('ls_childs');

            $.each($wrps, function (wrpix, wrp) {

                let $wrp = $(wrp);
                let nmid = $wrp.data('nmid');

                _pri.dbgR('    ls_childs:', ls_childs, ls_childs == 0);

                if (ls_childs == 0 && _pri.isObj(_pri.lss_childs_map))
                {
                    _pri.dbgR('YUP', [_pri.lss_childs_map]);
                    $.each(_pri.lss_childs_map, function (k, v) {

                        _pri.dbg('    k:', k, 'v:', {v: v});
                        if (_pri.isObj(v))
                        {
                            let i = 0;
                            let len = v.length;
                            let state = -1000;
                            for (i = 0; i < len; ++i)
                            {
                                _pri.dbg('        i:', i);

                                if (typeof states_map[v[i]] !== 'undefined' && states_map[v[i]] > state)
                                {
                                    state = states_map[v[i]];
                                    if (state == State.STATE_OK)
                                    {
                                        break;
                                    }
                                }
                            }

                            if (state > -1000)
                            {
                                if (typeof states_map[k] !== 'undefined' && states_map[k] < state)
                                {
                                    states_map[k] = state;
                                }
                                else
                                {
                                    states_map[k] = state;
                                }
                            }
                        }
                    });
                }

                if (typeof nmid !== 'undefined' && typeof _pri[nmid + '_min_h'] !== 'undefined')
                {
                    _pri.dbgY('    set min_h to:', _pri[nmid + '_min_h']);
                    $wrp.css('min-height', _pri[nmid + '_min_h']);
                }

                let $lss = $wrp.find('.crd-fe');
                let $elm, ls_id, state, cls, has_vc;

                // _pri.dbg('    lss:', $lss);

                $lss.each(function (k, v) {

                    $elm = $(v);

                    if (ls_childs == 1 && !$elm.data('has_vc'))
                    {
                        return;
                    }

                    ls_id = $elm.data('lc_id');

                    if (ls_childs == 0 && _pri.isObj(_pri.lss_childs_map) && typeof _pri.lss_childs_map[ls_id] === 'undefined' && !$elm.data('has_vc'))
                    {
                        return;
                    }

                    // _pri.dbg('        ls_id:', ls_id);

                    if (typeof states_map[ls_id] !== 'undefined')
                    {
                        state = states_map[ls_id];

                        // _pri.dbgG('        yup:', state);

                        if (state == State.STATE_OK || state == State.STATE_EXISTING)
                        {
                            // STATE_OK       ... admin in room
                            // STATE_EXISTING ... admin outside of room but logged in
                            cls = '1';
                        }
                        else if (state == State.STATE_BUSY)
                        {
                            cls = '2';
                        }
                        else
                        {
                            // STATE_ERR  ... room error
                            // STATE_NONE ... no admin
                            cls = '3';
                        }

                        $elm.data('stand_state', cls);
                        $elm.removeClass('state1 state2 state3').addClass('state' + cls);
                    }
                });

                let $sort_cb = $('#s_state_sort');
                _pri.dbgR('    $sort_cb.length', $sort_cb.length);

                if ($sort_cb.length == 0 || $sort_cb.is(":checked"))
                {
                    $lss.sort(_pri.sortLss);

                    _pri.dbgR('    -------- sorted:');

                    $lss.each(function (k, v) {

                        // $elm = $(v);
                        // ls_id = $elm.data('lc_id');
                        // cls = $elm.data('stand_state');
                        // _pri.dbg('        ls_id:', ls_id, 'stand_state:', cls);
                        $wrp.append(v);
                    });
                }

                if (typeof nmid !== 'undefined')
                {
                    setTimeout(function() {
                        _pri.dbgY('    outerHeight:', $wrp.outerHeight(), _pri[nmid + '_min_h']);
                        _pri.dbgY('    wrp.nmid:', $wrp.data('nmid'));
                        $wrp.css('min-height', '');
                        _pri['wrp_lss_']
                        _pri[nmid + '_min_h'] = $wrp.outerHeight();
                    }, 20);
                }
            });


            // let $wrp = $('#wrp_ls_vc_std');
            // let ls_childs = $wrp.data('ls_childs');
            //
            // _pri.dbgR('    ls_childs:', ls_childs, ls_childs == 0);
            //
            // if (ls_childs == 0 && _pri.isObj(_pri.lss_childs_map))
            // {
            //     _pri.dbgR('YUP', [_pri.lss_childs_map]);
            //     $.each(_pri.lss_childs_map, function (k, v) {
            //
            //         _pri.dbg('    k:', k, 'v:', {v: v});
            //         if (_pri.isObj(v))
            //         {
            //             let i = 0;
            //             let len = v.length;
            //             let state = -1000;
            //             for (i = 0; i < len; ++i)
            //             {
            //                 _pri.dbg('        i:', i);
            //
            //                 if (typeof states_map[v[i]] !== 'undefined' && states_map[v[i]] > state)
            //                 {
            //                     state = states_map[v[i]];
            //                     if (state == State.STATE_OK)
            //                     {
            //                         break;
            //                     }
            //                 }
            //             }
            //
            //             if (state > -1000)
            //             {
            //                 if (typeof states_map[k] !== 'undefined' && states_map[k] < state)
            //                 {
            //                     states_map[k] = state;
            //                 }
            //                 else
            //                 {
            //                     states_map[k] = state;
            //                 }
            //             }
            //         }
            //     });
            // }
            //
            // if (typeof _pri.wrp_lss_oh !== 'undefined')
            // {
            //     $wrp.css('min-height', _pri.wrp_lss_oh);
            // }
            //
            // let $lss = $wrp.find('.crd-fe');
            // let $elm, ls_id, state, cls;
            //
            // // _pri.dbg('    lss:', $lss);
            //
            // $lss.each(function (k, v) {
            //
            //     $elm = $(v);
            //     ls_id = $elm.data('lc_id');
            //     // _pri.dbg('        ls_id:', ls_id);
            //
            //     if (typeof states_map[ls_id] !== 'undefined')
            //     {
            //         state = states_map[ls_id];
            //
            //         // _pri.dbgG('        yup:', state);
            //
            //         if (state == State.STATE_OK)
            //         {
            //             cls = '1';
            //         }
            //         else if (state == State.STATE_BUSY)
            //         {
            //             cls = '2';
            //         }
            //         else
            //         {
            //             cls = '3';
            //         }
            //
            //         $elm.data('stand_state', cls);
            //         $elm.removeClass('state1 state2 state3').addClass('state' + cls);
            //     }
            // });
            //
            // if ($('#s_state_sort').is(":checked"))
            // {
            //     $lss.sort(_pri.sortLss);
            //
            //     // _pri.dbg('    -------- sorted:');
            //
            //     $lss.each(function (k, v) {
            //
            //         $elm = $(v);
            //         ls_id = $elm.data('lc_id');
            //         cls = $elm.data('stand_state');
            //         // _pri.dbg('        ls_id:', ls_id, 'stand_state:', cls);
            //         $wrp.append(v);
            //     });
            // }
            //
            // setTimeout(function() {
            //     let $wrp = $('#wrp_ls_vc_std');
            //     _pri.dbgY('    outerHeight:', $wrp.outerHeight());
            //     $wrp.css('min-height', '');
            //     _pri.wrp_lss_oh = $wrp.outerHeight();
            // }, 20);
            //
            //
            //
            //
            //
            // $wrp = $('#wrp_ls_vc_jw');
            //
            // if (typeof _pri.wrp_lssjw_oh !== 'undefined')
            // {
            //     $wrp.css('min-height', _pri.wrp_lssjw_oh);
            // }
            //
            // $lss = $wrp.find('.crd-fe');
            //
            // // _pri.dbg('    lss:', $lss);
            //
            // $lss.each(function (k, v) {
            //
            //     $elm = $(v);
            //     ls_id = $elm.data('lc_id');
            //     // _pri.dbg('        ls_id:', ls_id);
            //
            //     if (typeof states_map[ls_id] !== 'undefined')
            //     {
            //         state = states_map[ls_id];
            //
            //         // _pri.dbgG('        yup:', state);
            //
            //         if (state == State.STATE_OK)
            //         {
            //             cls = '1';
            //         }
            //         else if (state == State.STATE_BUSY)
            //         {
            //             cls = '2';
            //         }
            //         else
            //         {
            //             cls = '3';
            //         }
            //
            //         $elm.data('stand_state', cls);
            //         $elm.removeClass('state1 state2 state3').addClass('state' + cls);
            //     }
            // });
            //
            // if ($('#s_state_sort').is(":checked"))
            // {
            //     $lss.sort(_pri.sortLss);
            //
            //     // _pri.dbg('    -------- sorted:');
            //
            //     $lss.each(function (k, v) {
            //
            //         $elm = $(v);
            //         ls_id = $elm.data('lc_id');
            //         cls = $elm.data('stand_state');
            //         // _pri.dbg('        ls_id:', ls_id, 'stand_state:', cls);
            //         $wrp.append(v);
            //     });
            // }
            //
            // setTimeout(function() {
            //     let $wrp = $('#wrp_ls_vc_jw');
            //     _pri.dbgY('    outerHeight:', $wrp.outerHeight());
            //     $wrp.css('min-height', '');
            //     _pri.wrp_lssjw_oh = $wrp.outerHeight();
            // }, 20);
        }
    };

    _pri.sortLss = function(a, b)
    {
        let as = $(a).data('stand_state');
        let bs = $(b).data('stand_state');
        return (as > bs) ? 1 : (as < bs) ? -1 : 0;
    };

    // _pri.onConnect = function(e)
    // {
    //     _pri.dbgG('*** onConnect()');
    //     _pri.dbg('    lc_id_cur: ', _pri.lc_id_cur);
    // };

    // _pri.onAuth = function(e)
    // {
    //     _pri.dbgG('*** onAuth()');
    //     _pri.dbg('    lc_id_cur: ', _pri.lc_id_cur);
    // };

    _pri.setBusyChatBtn = function(busy)
    {
        var $btn = $('#btn-chat-busy');

        if ($btn.length == 1)
        {
            var $icon = $btn.find('i');

            if (typeof busy !== 'undefined')
            {
                $icon.removeClass('fa-refresh fa-spin fa-fw');
                $btn.data('busy', busy);

                if (busy)
                {
                    $btn.addClass('danger');
                    $icon.remove('fa-bell-o');
                    $icon.addClass('fa-bell-slash-o');
                    $btn.prop('title', 'Anklopfen ist ausgeschaltet \nBenutzer können sich aber weiterhin \nin die Warteliste eintragen');
                }
                else
                {
                    $btn.removeClass('danger');
                    $icon.removeClass('fa-bell-slash-o');
                    $icon.addClass('fa-bell-o');
                    $btn.prop('title', 'Anklopfen ausschalten \nBenutzer können sich aber weiterhin \nin die Warteliste eintragen');
                }
            }
            else
            {
                $icon.removeClass('fa-bell-o');
                $icon.addClass('fa-refresh fa-spin fa-fw');
            }
        }
    };

    _pri.busyChatClick = function(e)
    {
        e.preventDefault();

        _pri.dbg('*** busyChatClick()');

        var $this = $(this);

        if (!$this.data('disabled'))
        {
            $this.data('disabled', true);
            _pri.setBusyChatBtn();

            var busy        = $this.data('busy') ? true : false;
            var meta        = _pri.sioc.getMeta();
            meta.locked     = !busy;
            meta.room_id_to = _pri.sioc.getRoomIdByLcId(_pri.lc_id_cur);
            _pri.sioc.setRoomBusy(meta, function(meta) {

                _pri.dbg('>>> on setRoomBusy()', meta);

                _pri.setBusyChatBtn(meta.locked);
                $this.data('disabled', false);
            });
        }

    };

    _pri.leaveChatClick = function(e)
    {
        e.preventDefault();

        _pri.dbg('*** leaveChatClick()');

        if (_pri.$style_elm != null)
        {
            _pri.scaleChatClick();
        }

        var $this = $(this);
        _pri.loadLnk($this.attr('href'));

        return false;
    };

    _pri.scaleChatClick = function()
    {
        _pri.dbg('*** scaleChatClick()');

        if (_pri.$style_elm == null)
        {
            // _pri.$style_elm = document.head.appendChild(document.createElement("style"));
            //
            // style_elm.innerHTML = '#ifr_wrap:before {padding-top: ' + pt + '%;}';
            //
            // setTimeout(function(){
            // 	alert("Hello");
            //     document.head.removeChild(style_elm);
            // }, 3000);
            var win = window, a = 'inner';
            if (!('innerWidth' in window ))
            {
                a = 'client';
                win = document.documentElement || document.body;
            }
            var dim = { w : win[ a+'Width' ] , h : win[ a+'Height' ] };
            _pri.dbg('    dim:', dim);

            var pt = ((dim.h - 55) / dim.w) * 100;

            _pri.$style_elm = $('<style type="text/css">#page-top {overflow:hidden;} #wrp_chat {position:fixed; top:0; left:0; bottom:0; right:0; width:100vw; height:100vh; border:none; margin:0; padding:0; overflow:hidden; z-index:999999;} #ifr_wrap:before {padding-top: ' + pt + '%;} .chat-live-bg {border-radius: 0 !important;}</style>');
            $('head').append(_pri.$style_elm);

            $('#btn-chat-scale').html('<i class="fa fa-compress text-white" aria-hidden="true" title="Chat-Fenster verkleinern"></i>');
        }
        else
        {
            _pri.removeScale();
            $('#btn-chat-scale').html('<i class="fa fa-expand text-white" aria-hidden="true" title="Chat-Fenster vergrößern"></i>');
        }
    };

    _pri.removeScale = function()
    {
        _pri.$style_elm.remove();
        _pri.$style_elm = null;
    };

    _pri.onResizeDone = function(e, o)
    {
        // _pri.dbg('page:resize_done', o);
        _pri.resize();
    };

    _pri.resize = function()
    {
        if (_pri.$style_elm != null)
        {
            _pri.removeScale();
            _pri.scaleChatClick();
        }
    };

    _pri.extend();
    // publ.init();

    // expose public methods
    return publ;
})(jQuery);
